/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RunMetricFormat } from './RunMetricFormat';
import {
  RunMetricFormatFromJSON,
  RunMetricFormatFromJSONTyped,
  RunMetricFormatToJSON,
  RunMetricFormatToJSONTyped,
} from './RunMetricFormat';

/**
 *
 * @export
 * @interface ApiRunMetric
 */
export interface ApiRunMetric {
  /**
   * Required. The user defined name of the metric. It must between 1 and 63
   * characters long and must conform to the following regular expression:
   * `[a-z]([-a-z0-9]*[a-z0-9])?`.
   * @type {string}
   * @memberof ApiRunMetric
   */
  name?: string;
  /**
   * Required. The runtime node ID which reports the metric. The node ID can be
   * found in the RunDetail.workflow.Status. Metric with same (node_id, name)
   * are considerd as duplicate. Only the first reporting will be recorded. Max
   * length is 128.
   * @type {string}
   * @memberof ApiRunMetric
   */
  node_id?: string;
  /**
   * The number value of the metric.
   * @type {number}
   * @memberof ApiRunMetric
   */
  number_value?: number;
  /**
   *
   * @type {RunMetricFormat}
   * @memberof ApiRunMetric
   */
  format?: RunMetricFormat;
}

/**
 * Check if a given object implements the ApiRunMetric interface.
 */
export function instanceOfApiRunMetric(value: object): value is ApiRunMetric {
  return true;
}

export function ApiRunMetricFromJSON(json: any): ApiRunMetric {
  return ApiRunMetricFromJSONTyped(json, false);
}

export function ApiRunMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiRunMetric {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    node_id: json['node_id'] == null ? undefined : json['node_id'],
    number_value: json['number_value'] == null ? undefined : json['number_value'],
    format: json['format'] == null ? undefined : RunMetricFormatFromJSON(json['format']),
  };
}

export function ApiRunMetricToJSON(json: any): ApiRunMetric {
  return ApiRunMetricToJSONTyped(json, false);
}

export function ApiRunMetricToJSONTyped(
  value?: ApiRunMetric | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    node_id: value['node_id'],
    number_value: value['number_value'],
    format: RunMetricFormatToJSON(value['format']),
  };
}
